// extracted by mini-css-extract-plugin
var _1 = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol";
var _2 = "x3CEE__wheel";
export { _1 as "font", _2 as "wheel" }
